var map = {
	"./dept1.png": "24a1",
	"./dept2.png": "fd57",
	"./dept3.png": "dea7",
	"./role.prj.png": "292d",
	"./role.spec.png": "4ab3",
	"./role.system.png": "c73d",
	"./spec.png": "ccd2",
	"./tag.png": "6429",
	"./user.png": "99ab",
	"./user.prj1.png": "43ad",
	"./user.prj2.png": "74aa",
	"./user.prj3.png": "d110",
	"./user.role.png": "aab7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "706a";